/* eslint-disable import/order */
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { componentWithCondition } from '@jira/platform__utils-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmChatopsAndVideosToolsRoute } from '@jira/router-routes__products-jsm-chatops-and-videos-tools-routes/src/productsJsmChatopsAndVideosToolsRoute.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ProductsJsmChatopsAndVideoTools, {
	LazyProductsJsmChatopsAndVideoTools,
} from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const productsJsmChatopsAndVideosToolsRouteEntry: Route = createEntry(
	productsJsmChatopsAndVideosToolsRoute,
	() => ({
		group: 'global-settings',

		// eslint-disable-next-line no-restricted-syntax
		component: componentWithCondition(
			() =>
				!isFeatureEnabled('jira-service-management', 'jsm-chat-ops') &&
				!fg('fix_chatops_access_in_isolated_cloud'),
			ErrorPagesNotFound,
			ProductsJsmChatopsAndVideoTools,
		),

		layout: opsSettingsLayout,

		navigation: {
			menuId: MenuIdSettings,
			...getNavigationSpecifications(),
		},

		resources: [...getNavigationResources(), ...getNavigationSidebarProductsSettingResource()],

		forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyProductsJsmChatopsAndVideoTools],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
